require('./ctxSearchBox.style.scss');
const DEBOUNCE_DELAY = 500;
class CtxSearchBoxController {
    constructor($scope, $timeout) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$scope.$watch(() => this.value, (newValue, oldValue) => {
            this.$timeout(() => {
                if (angular.isUndefined(newValue) || (!newValue && angular.isUndefined(oldValue)) || newValue === oldValue) return;
                this.callbackFn();
            }, 0);
        });
        this.ngModelOptions = {};
        this.customId = this.customId ? this.customId : "search-" + Math.floor(Math.random() * 1000);
    }

    $onInit() {
        if (this.incremental === 'true') {
            this.ngModelOptions.debounce = DEBOUNCE_DELAY;
        }
        else {
            this.ngModelOptions.updateOn = 'blur';
        }
    }
}

const ctxSearchBoxComponent = {
    controller: CtxSearchBoxController,
    scope: {},
    template: require('./ctxSearchBox.template.html'),
    bindings: {
        value: '=',
        incremental: '@?',
        callbackFn: '&',
        customPlaceholder: '<?',
        autoComplete: '@?',
        hideClose: '<?',
        customId: '<?'
    }
};

CtxSearchBoxController.$inject = ['$scope', '$timeout'];

module.exports = ctxSearchBoxComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxSearchBox/ctxSearchBox.component.js